import { StyleSheet, ViewStyle } from 'react-native'

import { ThemeProps } from '@common/styles/themeConfig'

// Local layout constants for the receive popup card (radii the theme doesn't express).
export const RECEIVE_RADII = {
  lg: 16,
  pill: 100
} as const

interface Style {
  header: ViewStyle
  closeButton: ViewStyle
  qrBox: ViewStyle
  addressPill: ViewStyle
  networks: ViewStyle
  network: ViewStyle
  seeMore: ViewStyle
}

const getStyles = (theme: ThemeProps) =>
  StyleSheet.create<Style>({
    header: {
      position: 'relative',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 28
    },
    closeButton: {
      position: 'absolute',
      right: 0,
      top: 0,
      width: 32,
      height: 32,
      borderRadius: 16,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.tertiaryBackground as string
    },
    qrBox: {
      backgroundColor: '#FFFFFF',
      borderRadius: RECEIVE_RADII.lg,
      padding: 16,
      alignItems: 'center',
      justifyContent: 'center'
    },
    addressPill: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'center',
      maxWidth: '100%',
      borderRadius: RECEIVE_RADII.pill,
      backgroundColor: theme.quaternaryBackground as string,
      paddingVertical: 8,
      paddingHorizontal: 16
    },
    networks: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12
    },
    network: {
      alignItems: 'center',
      justifyContent: 'center'
    },
    seeMore: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  })

export default getStyles
